/** Flat circular CSAT faces (red → green scale). */
const FACE_BY_SCORE: Record<
  1 | 2 | 3 | 4 | 5,
  { fill: string; feature: string; mouth: 'sad-deep' | 'sad' | 'neutral' | 'smile' | 'smile-wide' }
> = {
  1: { fill: '#F44336', feature: '#B71C1C', mouth: 'sad-deep' },
  2: { fill: '#FF9800', feature: '#E65100', mouth: 'sad' },
  3: { fill: '#FFEB3B', feature: '#F9A825', mouth: 'neutral' },
  4: { fill: '#8BC34A', feature: '#558B2F', mouth: 'smile' },
  5: { fill: '#2E7D32', feature: '#1B5E20', mouth: 'smile-wide' },
}

function Mouth({
  variant,
  color,
}: {
  variant: (typeof FACE_BY_SCORE)[1]['mouth']
  color: string
}) {
  const stroke = color
  const sw = 3
  switch (variant) {
    case 'sad-deep':
      return (
        <path
          d="M 24 54 Q 40 42 56 54"
          fill="none"
          stroke={stroke}
          strokeWidth={sw}
          strokeLinecap="round"
        />
      )
    case 'sad':
      return (
        <path
          d="M 27 53 Q 40 47 53 53"
          fill="none"
          stroke={stroke}
          strokeWidth={sw}
          strokeLinecap="round"
        />
      )
    case 'neutral':
      return (
        <line
          x1="28"
          y1="54"
          x2="52"
          y2="54"
          stroke={stroke}
          strokeWidth={sw}
          strokeLinecap="round"
        />
      )
    case 'smile':
      return (
        <path
          d="M 27 50 Q 40 58 53 50"
          fill="none"
          stroke={stroke}
          strokeWidth={sw}
          strokeLinecap="round"
        />
      )
    case 'smile-wide':
      return (
        <path
          d="M 22 48 Q 40 66 58 48"
          fill="none"
          stroke={stroke}
          strokeWidth={sw}
          strokeLinecap="round"
        />
      )
    default:
      return null
  }
}

export interface CsatScoreFaceProps {
  score: 1 | 2 | 3 | 4 | 5
  className?: string
}

export function CsatScoreFace({ score, className = 'h-12 w-12' }: CsatScoreFaceProps) {
  const { fill, feature, mouth } = FACE_BY_SCORE[score]

  return (
    <svg
      viewBox="0 0 80 80"
      className={className}
      aria-hidden="true"
    >
      <circle cx="40" cy="40" r="38" fill={fill} />
      <ellipse cx="28" cy="32" rx="5" ry="7" fill={feature} />
      <ellipse cx="52" cy="32" rx="5" ry="7" fill={feature} />
      <Mouth variant={mouth} color={feature} />
    </svg>
  )
}
